function MeanBits(meanBits) {
	this.bits = meanBits
}

export default MeanBits
